import React from 'react';
import styles from './RequirementsView.module.scss';

interface RequirementItem {
  id: string;
  title: string;
  description: string;
}

const requirements: RequirementItem[] = [
  {
    id: '1',
    title: 'Юридический статус',
    description: 'Являться юридическим лицом — резидентом Российской Федерации',
  },
  {
    id: '2',
    title: 'Опыт работы',
    description: 'Компания должна осуществлять хозяйственную деятельность более 2 (двух) полных календарных года с даты государственной регистрации.',
  },
  {
    id: '3',
    title: 'Деловая активность',
    description: 'Находиться в статусе действующего юридического лица. Не находиться в стадии ликвидации, реорганизации с последующей ликвидацией или в какой либо из процедур банкротства.',
  },
  {
    id: '4',
    title: 'Финансовый результат',
    description: 'По итогам последнего завершенного отчётного периода деятельность компании должна быть прибыльной',
  },
  {
    id: '5',
    title: 'Отсутствие судебных рисков',
    description: 'Отсутствие активных судебных дел по процедуре банкротства, в которых заёмщик выступает в качестве ответчика',
  },
  {
    id: '6',
    title: 'Финансовый порог',
    description: 'Годовая выручка компании за последний завершённый отчётный период (по данным финансовой отчётности) должна составлять не менее 100 (ста) миллионов рублей',
  },
];

const RequirementsView = () => {
  return (
    <div className={styles.requirementsView}>
      <h1 className={styles.title}>Требования к заемщикам</h1>

      <div className={styles.cardsGrid}>
        {requirements.map((req) => (
          <div key={req.id} className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.checkIcon}>
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className={styles.cardTitle}>{req.title}</h3>
            </div>
            <p className={styles.cardDescription}>{req.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequirementsView;

